"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useVideoSuspenders = void 0;

var _react = _interopRequireWildcard(require("react"));

var _ = require(".");

var _VideoController = require("./controllers/VideoController");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal
 */

/**
 * useVideoSuspenders returns two methods to resume and pause a video
 *
 * @param {*} ref
 * @return {*} 
 */
var useVideoSuspenders = function useVideoSuspenders(ref) {
  var _useVideoControls = (0, _.useVideoControls)(ref),
      play = _useVideoControls.play,
      pause = _useVideoControls.pause,
      videoController = _useVideoControls.videoController;

  var wasPaused = false;
  var otherController = _VideoController.VideoController._instances.length > 0 ? _VideoController.VideoController._instances[0] : null;

  var suspend = function suspend() {
    if (videoController) {
      wasPaused = videoController.paused;
    } else if (otherController) {
      wasPaused = otherController.paused;
    } else {
      wasPaused = false;
    }

    pause();
  };

  var resume = function resume() {
    if (!wasPaused) {
      play();
    }
  };

  return {
    suspend: suspend,
    resume: resume
  };
};

exports.useVideoSuspenders = useVideoSuspenders;